import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { concatAndDeDuplicateObjects } from '@/lib/utils';

interface StateItem {
  id: string;
  [key: string]: any;
}

interface StatesState {
  items: StateItem[];
  loading: boolean;
  error: string | null;
}

const initialState: StatesState = {
  items: [],
  loading: false,
  error: null,
};

const statesSlice = createSlice({
  name: 'states',
  initialState,
  reducers: {
    // Action creators for Redux Offline
    addJobState: (state, action: PayloadAction<StateItem>) => {
      state.items = [action.payload, ...state.items];
    },
    addJobStateCommit: (state) => {
      // Handle success if needed
    },
    addJobStateFailed: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },

    updateJobState: (state, action: PayloadAction<StateItem>) => {
      const index = state.items.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    updateJobStateCommit: (state) => {
      // Handle success if needed
    },
    updateJobStateFailed: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase('GET_BOOKINGS_COMMIT', (state, action: PayloadAction<{
      states?: StateItem[];
      page?: number;
    }>) => {
      if (action.payload.page) {
        if (action.payload.states && action.payload.states.length > 0) {
          state.items = concatAndDeDuplicateObjects('id', state.items, action.payload.states);
        }
      } else {
        state.items = action.payload.states || [];
      }
    });
  },
});

export const {
  addJobState,
  addJobStateCommit,
  addJobStateFailed,
  updateJobState,
  updateJobStateCommit,
  updateJobStateFailed,
} = statesSlice.actions;

export default statesSlice.reducer;

// Selectors
export const selectStatesByJobId = (state: any, jobId: string) => {
  return state.states.items.filter((stateItem: StateItem) => stateItem.job_id === jobId);
};